import { apiBaseUrl } from 'app/src/msw/moneytransfer/staticapi/apiBaseurl'
import { confirmTransferResponseMock } from 'app/src/msw/stories/transfers-stories-mock'
import type { moneytransferApi } from 'app/src/services/welfareportal'
import { HttpResponse } from 'msw'
import { http } from 'msw/core/http'

export const confirmTransfer = http.post<
  { transferId: string },
  moneytransferApi.TransferConfirm,
  moneytransferApi.TransferResponse | moneytransferApi.ErrorModel
>(apiBaseUrl + '/transfers/:transferId/confirm', async ({ params, request }) => {
  console.log('MSW: Confirm Transfer called with transferId:', params.transferId)
  const body = await request.json()
  console.log('MSW: Confirm Transfer called with body:', body)
  console.log('MSW: Confirm Transfer mocked response being returned')

  if (params.transferId === 'ERRORTRANSFER') {
    const responseError = {
      status: 400,
      title: 'Errore Bad Request',
      type: 'urn:badreq',
      rc: 404,
    }
    return HttpResponse.json(responseError, { status: 404 })
  }

  const transferResponse: moneytransferApi.TransferResponse = confirmTransferResponseMock

  return new HttpResponse(JSON.stringify(transferResponse), {
    status: 200,
    headers: {
      'Content-Type': 'application/json',
    },
  })
})
